import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
} from 'react-router-dom';
import { useSelector } from 'react-redux';

import AuthProvider from './AuthProvider';
import { isUserLoggedIn } from '../store/selectors/user';
import { EMPTY_ROUTE, PAGE_LOGIN, PAGE_START } from '../constants/routes';
import LoginPage from '../pages/login';
import PlannerPage from '../pages/planner';
import SomethingWentWrong from '../components/SomethingWentWrong';

const PublicLayout = () => {
  const userLogged = useSelector(isUserLoggedIn);

  if (userLogged) {
    return <Navigate to={PAGE_START} replace />;
  }
  return <Outlet />;
};

const ProtectedLayout = () => {
  const userLogged = useSelector(isUserLoggedIn);
  if (!userLogged) {
    return <Navigate to={PAGE_LOGIN} replace />;
  }
  return <Outlet />;
};

const AppRouter = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AuthProvider />} errorElement={<SomethingWentWrong />}>
      <Route element={<PublicLayout />}>
        <Route path={PAGE_LOGIN} element={<LoginPage />} />
      </Route>

      <Route element={<ProtectedLayout />}>
        <Route path="/*" element={<PlannerPage />} />
      </Route>
      <Route
        path={EMPTY_ROUTE}
        element={<Navigate to={PAGE_START} replace />}
      />
    </Route>
  )
);

export default AppRouter;
